import { atomWithStorage } from "jotai/utils";

export const AUTO_UPDATE_STORAGE_KEY = "auto-update";

export const autoUpdateEnabledAtom = atomWithStorage(
  AUTO_UPDATE_STORAGE_KEY,
  false,
  undefined,
  { getOnInit: true },
);
